import React from 'react'
import { useParams } from 'react-router-dom';
import UserAnalytics from '../../../components/Dashboards/Admin/UserAnalytics';

function UsersAnalyticsPage() {
  const { id } = useParams();
  return <UserAnalytics company_id={id as string} />;
}

export default UsersAnalyticsPage